import { NavLink } from 'react-router-dom';
import Goto from '../Goto/Goto';
import './footer.css';
import { Button } from "@mui/material";
const Footer=()=>{
    const date=new Date();
    const setDate=date.getFullYear();
    const design=(
        <>
            <div className="container-fluid p-4  contact-section" id='contact'>
                    <div className="row">
                        <h2>Contact</h2>
                       <div className="row">
                       <div className="col-md-3 mt-4">
                        <h3>AKHZAR AZMI</h3>
                        <p>I'm a Complete B-Tech in Computer Science & Engineering at Integral University from Lucknow I'm React Js Frontend Developer.</p>
                       </div>
                        <div className="col-md-4">
                            <div className="row mx-5 mt-4">
                                <div className="col-md-1 d-flex justify-content-center align-items-center icon-box">
                                <a href="https://maps.app.goo.gl/wttxihsYBCvUNvG17"><i class="fa-solid fa-location-dot"></i></a>
                                </div>
                                <div className="col-md-11">
                                    <h5>Loaction:</h5>
                                    <p>Takiya/Azamgarh U.P</p>
                                </div>
                            </div>
                            <div className="row mx-5 mt-4">
                                <div className="col-md-1 d-flex justify-content-center align-items-center icon-box">
                               <a href="mailto:akhzarazmi@gmail.com"><i class="fa-regular fa-envelope"></i></a>
                                </div>
                                <div className="col-md-11">
                                    <h5>Email:</h5>
                                    <p>akhzarazmi@gmail.com</p>
                                </div>
                            </div>
                            <div className="row mx-5 mt-4">
                                <div className="col-md-1 d-flex justify-content-center align-items-center icon-box">
                                
                                <a href="tel:7860754122"><i class="fa-solid fa-phone"></i></a>
                                </div>
                                <div className="col-md-11">
                                    <h5>Call:</h5>
                                    <p>+91 7860754122</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                        <form action="https://formspree.io/f/xqkvgebq" method='post'>
                          <div className="row mb-4">
                                <div className="col-md-6">
                                    <input type="text" className='form-control mb-3 shadow-none'  name='username' placeholder='Enter Your Name' required/>
                                </div>
                                <div className="col-md-6">
                                <input type="email" className='form-control shadow-none' name='email' placeholder='akexample@gmail.com' required/>
                                </div>
                            </div>
                            <input type="text" className='form-control mb-4 shadow-none' placeholder='Subject' name='subject' required/>
                            <textarea className='form-control mb-4 shadow-none' name='message' placeholder='Message' rows="7" required></textarea>
                            <div align="center">
                            <Button type="submit" variant='contained'>Submit</Button>
                            </div>
                          </form>
                        </div>
                       </div>
                    </div>
            </div>
            <div className='container-fluid shadow-lg text-center footer-section'>
             <h2 className='pt-4'>Join Media Link </h2>
             <p>Connect With me On Social Media <br /> and Send me Your Thoughts and Message me For Any Help.. <br /> <b>Thanks You !</b></p>
              <div className='icon-box d-flex justify-content-center align-items-center'>
              <a href="https://wa.me/7860754122"><i class="fa-brands fa-whatsapp"></i></a>
              <a href="https://www.instagram.com/er.akhzar_azmi"><i class="fa-brands fa-instagram"></i></a>
              <a href="https://www.facebook.com/akhzarazmi.5"><i class="fa-brands fa-facebook"></i></a>
              <a href="https://www.linkedin.com/in/mohd-akhzar-2484561b0"><i class="fa-brands fa-linkedin"></i></a>
              </div>
              <p className='pt-4'>Copyright © {setDate} <span>MOHD AKHZAR</span> All Rights Reserved</p>
              <h6>Designed by <i className='fa fa-heart' style={{color:"#DD5A92"}}></i> <span>Er. Akhzar Azmi</span></h6>
              <Goto/>
            <br /><br />
            </div>
        </>
    )
    return design;
}
export default Footer;